export const costsConfig = {
  decimal: '.',
  thousands: ' ',
  prefix: '',
  suffix: '',
  precision: 2,
  masked: false
}
